import DropDownButton from "devextreme-react/drop-down-button";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from "../../state/reducers";
import "./namhoc.css";
type NamHocDropDownTextProps = {
    showArrowIcon?: boolean,
    value?: string,
    preText?: string,
    onSelectionChanged: (nam_hoc: string) => void,
    placeHolder?: string
}
export const NamHocDropDownText = (props: NamHocDropDownTextProps) => {
    const dm_namhocs = useSelector((state: RootState) => state.categorySource.dm_namhocs);
    const dm_namhoc_selected = dm_namhocs.find(x => x.nam_hoc == props.value);
    const text = useMemo(() => {
        if (dm_namhoc_selected) return (props.preText || "") + dm_namhoc_selected.nam_hoc;
        if (props.placeHolder) return props.placeHolder
        return "Chọn năm";
    }, [props.placeHolder, dm_namhoc_selected])
    const dispatch = useDispatch();
    useEffect(() => {
        if (dm_namhocs.length === 0) dispatch(actions.categorySource.loadNamHocStart())
    }, []);
    return (
        <DropDownButton showArrowIcon={props.showArrowIcon || false}
            stylingMode="text"
            text={text}
            dataSource={dm_namhocs}
            displayExpr="nam_hoc"
            keyExpr="id"
            className={`NamHocDropDownText ${dm_namhoc_selected ? "selected" : ""}`}
            dropDownOptions={{
                wrapperAttr: {
                    class: `NamHocDropDownText-DropdownPopup`
                }
            }}
            onSelectionChanged={(e: any) => { props.onSelectionChanged(e.item.nam_hoc) }}
        ></DropDownButton>
    );
}

